var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyzingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000008990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.6151 1.25L14.6096 6.4023L19.9997 8.30882L14.6096 10.2153L12.6151 15.3677L10.6206 10.2153L5.23047 8.30882L10.6206 6.4023L12.6151 1.25Z",
    fill: "#1e0af5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M12.6151 1.25L14.6096 6.4023L19.9997 8.30882L14.6096 10.2153L12.6151 15.3677L10.6206 10.2153L5.23047 8.30882L10.6206 6.4023L12.6151 1.25Z;M9.81043 5.23718L12.5476 6.49579L15.2848 5.23718L14.0262 7.97437L15.2848 10.7116L12.5476 9.45294L9.81043 10.7116L11.069 7.97437L9.81043 5.23718Z;M12.6151 1.25L14.6096 6.4023L19.9997 8.30882L14.6096 10.2153L12.6151 15.3677L10.6206 10.2153L5.23047 8.30882L10.6206 6.4023L12.6151 1.25Z",
    begin: "0s",
    dur: "4s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M4.30769 10L6.05 12.4522L8.61538 14.1176L6.05 15.7831L4.30769 18.2353L2.56538 15.7831L0 14.1176L2.56538 12.4522L4.30769 10Z",
    fill: "#1e0af5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M4.30769 10L6.05 12.4522L8.61538 14.1176L6.05 15.7831L4.30769 18.2353L2.56538 15.7831L0 14.1176L2.56538 12.4522L4.30769 10Z;M8.54005 10.2485L8.23497 11.8452L8.54005 13.4419L6.94336 13.1369L5.34667 13.4419L5.65175 11.8452L5.34667 10.2485L6.94336 10.5536L8.54005 10.2485Z;M4.30769 10L6.05 12.4522L8.61538 14.1176L6.05 15.7831L4.30769 18.2353L2.56538 15.7831L0 14.1176L2.56538 12.4522L4.30769 10Z",
    begin: "0s",
    dur: "4s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M3.92349 2.5L4.98132 3.98884L6.53887 5L4.98132 6.01116L3.92349 7.5L2.86566 6.01116L1.30811 5L2.86566 3.98884L3.92349 2.5Z",
    fill: "#1e0af5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M3.92349 2.5L4.98132 3.98884L6.53887 5L4.98132 6.01116L3.92349 7.5L2.86566 6.01116L1.30811 5L2.86566 3.98884L3.92349 2.5Z;M7.18506 5L8.19622 6.48884L9.68506 7.5L8.19622 8.51116L7.18506 10L6.1739 8.51116L4.68506 7.5L6.1739 6.48884L7.18506 5Z;M3.92349 2.5L4.98132 3.98884L6.53887 5L4.98132 6.01116L3.92349 7.5L2.86566 6.01116L1.30811 5L2.86566 3.98884L3.92349 2.5Z",
    begin: "0s",
    dur: "4s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#4F4D55;#1B4DFF;#4F4D55",
    begin: "0s",
    dur: "4s",
    repeatCount: "indefinite",
    fill: "freeze",
    calcMode: "linear",
    keyTimes: "0;0.5;1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzingIcon);
export default __webpack_public_path__ + "static/media/analyzing-icon.223f0f4509cfb3c55757e8215829bb6a.svg";
export { ForwardRef as ReactComponent };